interface AdminErrorBannerProps {
  message: string | null;
}

const AdminErrorBanner = ({ message }: AdminErrorBannerProps) => {
  if (!message) return null;

  return (
    <div className="rounded-lg border border-rose-200 bg-rose-50 px-4 py-3 text-xs text-rose-700">
      {message}
    </div>
  );
};

export default AdminErrorBanner;
